export default __webpack_public_path__ + "static/media/ORGAN BASS_1.710db5a8.wav";